// extracted by mini-css-extract-plugin
module.exports = {"btnNote":"Note_btnNote__UAJ9s"};